import { getIsoToCountryNames } from "./ISO_TO_COUNTRY_NAME";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "./THREE_LETTER_PRIMARY_COUNTRY_CODES";
/**
 * A function is required so we can change what is returned by localize
 * in a node environment where locale may change, e.g. web-email-server.
 */ export var getPrimaryCountriesIsoToCountryName = function(strictLocalize) {
    var isoToCountryNames = getIsoToCountryNames(strictLocalize);
    return Object.values(THREE_LETTER_PRIMARY_COUNTRY_CODES).reduce(function(acc, value) {
        acc[value] = isoToCountryNames[value];
        return acc;
    }, {});
};
export var PRIMARY_COUNTRIES_ISO_TO_COUNTRY_NAME = function(strictLocalize) {
    return getPrimaryCountriesIsoToCountryName(strictLocalize);
};
